'use client';
import * as e from 'react';
import { composeEventHandlersUtil } from '../utilities/compose-event-handlers.util.js';
import { createClickOnSpaceHandler, createClickOnEnterHandler } from '../utilities/event-handlers.util.js';

function useNonButtonElementAsButton(r) {
    let u = e.useRef(null), l = {
        role: 'button',
        tabIndex: 0,
        onKeyPress: composeEventHandlersUtil(r, createClickOnEnterHandler(u), createClickOnSpaceHandler(u))
    };
    return [
        u,
        l
    ];
}
function useNonAnchorElementAsAnchor(o) {
    let r = e.useRef(null), u = {
        role: 'link',
        tabIndex: 0,
        onKeyPress: composeEventHandlersUtil(o, createClickOnEnterHandler(r))
    };
    return [
        r,
        u
    ];
}

export { useNonAnchorElementAsAnchor, useNonButtonElementAsButton };
